import { configureStore } from '@reduxjs/toolkit'
import checkReducer from "./slice/personalBackgrountCheckSlice"
import appReducer from "./slice/appSlice";

export const store = configureStore({
    reducer: {
        backgroundCheck: checkReducer,
        appSlice: appReducer,
    }
})